import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { computadorComAppDoWhatsApp, guardaUsoDoApp, usaOAppNesteComputador } from "@/lib/whatsappApp";

// Nos envios de status: abrir a mensagem no aplicativo do WhatsApp deste computador, sem aba nova (ver lib/whatsappApp).
// A escolha fica guardada no computador, não na loja.
export function OpcaoAppWhatsApp() {
  const [usa, setUsa] = useState(usaOAppNesteComputador);
  if (!computadorComAppDoWhatsApp()) return null;
  return (
    <div className="flex items-start gap-2 px-4 pb-4">
      <Checkbox
        id="whatsapp-no-app"
        checked={usa}
        onCheckedChange={(v) => {
          setUsa(v === true);
          guardaUsoDoApp(v === true);
        }}
        className="mt-0.5"
        data-testid="whatsapp-no-app"
      />
      <label htmlFor="whatsapp-no-app" className="text-sm cursor-pointer leading-snug">
        Abrir no aplicativo do WhatsApp deste computador
        <span className="block text-xs text-muted-foreground">
          Sem abrir aba nova. Só funciona se este computador tiver o WhatsApp instalado.
        </span>
      </label>
    </div>
  );
}
